import { BrowserModule } from '@angular/platform-browser'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatButtonModule } from '@angular/material/button'
import { MenuComponent } from './ui-portal/menu/menu.component'
import { LoginUserComponent } from './account/login-user/login-user.component'
import { GoogleMapsModule } from '@angular/google-maps'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { ReactiveFormsModule } from '@angular/forms'
import { HomeComponent } from './ui-portal/home/home.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInputModule } from '@angular/material/input'
import { MatIconModule } from '@angular/material/icon'
import { ChartsModule } from 'ng2-charts'
import { MatCardModule } from '@angular/material/card'
import {
  BottomSheetOverviewReceivingPDF,
  DialogOverviewExampleDialog,
  ShippingComponent
} from './ui-portal/shipping/shipping.component'
import { HeaderComponent } from './ui-portal/header/header.component'
import { MatTabsModule } from '@angular/material/tabs'
import { MatSelectModule } from '@angular/material/select'
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import {
  MAT_COLOR_FORMATS,
  NgxMatColorPickerModule,
  NGX_MAT_COLOR_FORMATS
} from '@angular-material-components/color-picker'
import { ColorSketchModule } from 'ngx-color/sketch'

import { FontPickerModule } from 'ngx-font-picker'
import { FONT_PICKER_CONFIG } from 'ngx-font-picker'
import { FontPickerConfigInterface } from 'ngx-font-picker'

import { NgxFileDropModule } from 'ngx-file-drop'
import { ReceiveComponent } from './ui-portal/receive/receive.component'
import { FormsModule } from '@angular/forms'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatSortModule } from '@angular/material/sort'
import { ReportsComponent } from './ui-portal/reports/reports.component'
import { ContainersComponent } from './ui-portal/containers/containers.component'
import { ProductsComponent } from './ui-portal/products/products.component'
import { CustomersComponent } from './ui-portal/customers/customers.component'
import { AdministradorComponent } from './ui-portal/administrador/administrador.component'
import { ChatSignalRComponent } from './ui-portal/chat-signal-r/chat-signal-r.component'
import { EncrDecrService } from './_services'
import { MatDividerModule } from '@angular/material/divider'
import { CdkTableModule } from '@angular/cdk/table'
import {
  ClientComponent,
  DialogOverviewclientDialog
} from './ui-portal/client/client.component'
import { ShiptordersComponent } from './ui-portal/shiptorders/shiptorders.component'
import { NgxBarcodeModule } from 'ngx-barcode'
import { AppareanceComponent } from './ui-portal/appareance/appareance.component'
import { ConfirmProductReceivingComponent } from './ui-portal/modal/confirm-product-receiving/confirm-product-receiving.component'
import {
  MatDialogModule,
  MAT_DIALOG_DEFAULT_OPTIONS
} from '@angular/material/dialog'
import { EditProductsItemsComponent } from './ui-portal/modal/edit-products-items/edit-products-items.component'
import { UpdateMoveInventoryComponent } from './ui-portal/modal/update-move-inventory/update-move-inventory.component'
import { FontServiceService } from './_services/font-service.service'
import { CodeBarScannerComponent } from './ui-portal/modal/code-bar-scanner/code-bar-scanner.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { AddProductsModalComponent } from './ui-portal/modal/add-products-modal/add-products-modal.component'
import { MatSelectFilterModule } from 'mat-select-filter'
import { EditProductReceivingComponent } from './ui-portal/modal/edit-product-receiving/edit-product-receiving.component'
import { NgxSpinnerModule } from 'ngx-spinner'
import { MasivoConfimacionReceivingComponent } from './ui-portal/modal/masivo-confimacion-receiving/masivo-confimacion-receiving.component'
import { PalletLabelComponent } from './ui-portal/pdf/pallet-label/pallet-label.component'
import { OpcionesComponent } from './ui-portal/pdf/opciones/opciones.component'
const DEFAULT_FONT_PICKER_CONFIG: FontPickerConfigInterface = {
  // Change this to your Google API key
  apiKey: 'AIzaSyA9S7DY0khhn9JYcfyRWb1F6Rd2rwtF_mA'
}
import { MatBottomSheetModule } from '@angular/material/bottom-sheet'
import { MatListModule } from '@angular/material/list'
import { SignalRService } from './_services/signal-r.service'
import { AddTypeLocationsComponent } from './modal/add-type-locations/add-type-locations.component'
import { ChatPortalComponent } from './ui-portal/chat-portal/chat-portal.component'
import { DataTablesModule } from 'angular-datatables'
import { ReportsImsComponent } from './ui-portal/reports-ims/reports-ims.component'
import { ReceivePallentsComponent } from './ui-portal/receive-pallents/receive-pallents.component'
import {
  DEFAULT_TIMEOUT,
  TimeoutInterceptor
} from './_services/timeout.interceptor'
import { MatMenuModule } from '@angular/material/menu'
import { EditPalletCustomersComponent } from './ui-portal/modal/edit-pallet-customers/edit-pallet-customers.component'
import { PdfBillOfLadingComponent } from './ui-portal/modal/pdf-bill-of-lading/pdf-bill-of-lading.component'
import { ConfirmContainerItemsComponent } from './ui-portal/modal/confirm-container-items/confirm-container-items.component'
import { AddBillToComponent } from './ui-portal/modal/add-bill-to/add-bill-to.component'
import { ContainersClientComponent } from './ui-portal/containers-client/containers-client.component'
import { PdfKemfloComponent } from './ui-portal/modal/pdf-kemflo/pdf-kemflo.component'
import { ReceivingImportExcelComponent } from './ui-portal/modal/receiving-import-excel/receiving-import-excel.component'
import { ContainerListPdfComponent } from './ui-portal/modal/container-list-pdf/container-list-pdf.component'
import { ContainerBillOfLadingComponent } from './ui-portal/modal/container-bill-of-lading/container-bill-of-lading.component'
import { ImportShippingFaseOneComponent } from './ui-portal/modal/import-shipping-fase-one/import-shipping-fase-one.component'
import { NgxDynamicTabindexModule } from 'ngx-dynamic-tabindex'
import { ImportReceivingExcelReferenceComponent } from './ui-portal/modal/import-receiving-excel-reference/import-receiving-excel-reference.component'
import { InvoiceGenerateComponent } from './ui-portal/invoice-generate/invoice-generate.component'
import { AddRateProductComponent } from './ui-portal/modal/add-rate-product/add-rate-product.component'
import { AddSendEmailComponent } from './ui-portal/modal/add-send-email/add-send-email.component'
import { ReceivingExportProdutsToShippingComponent } from './ui-portal/modal/receiving-export-produts-to-shipping/receiving-export-produts-to-shipping.component'
import { ReportProductReceiveridComponent } from './ui-portal/modal/report-product-receiverid/report-product-receiverid.component'
import { ExportShippingProductsComponent } from './ui-portal/modal/export-shipping-products/export-shipping-products.component'
import { WarehouseNameLocationComponent } from './ui-portal/modal/warehouse-name-location/warehouse-name-location.component'
import { WarehouseNameLocationViewComponent } from './ui-portal/warehouse-name-location/warehouse-name-location.component';
import { LoginAppComponent } from './account/login-app/login-app.component';
import { EditInventoryComponent } from './ui-portal/edit-inventory/edit-inventory.component'

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    LoginUserComponent,
    HomeComponent,
    HeaderComponent,

    ReceiveComponent,
    ReportsComponent,
    ContainersComponent,
    ProductsComponent,
    CustomersComponent,
    AdministradorComponent,
    ChatSignalRComponent,
    ShippingComponent,
    DialogOverviewExampleDialog,
    ClientComponent,
    ShiptordersComponent,
    AppareanceComponent,
    ConfirmProductReceivingComponent,
    EditProductsItemsComponent,
    UpdateMoveInventoryComponent,
    CodeBarScannerComponent,
    AddProductsModalComponent,
    EditProductReceivingComponent,
    ClientComponent,
    DialogOverviewclientDialog,
    MasivoConfimacionReceivingComponent,
    PalletLabelComponent,
    OpcionesComponent,
    BottomSheetOverviewReceivingPDF,
    AddTypeLocationsComponent,
    ChatPortalComponent,
    ReportsImsComponent,
    ReceivePallentsComponent,
    EditPalletCustomersComponent,
    PdfBillOfLadingComponent,
    ConfirmContainerItemsComponent,
    AddBillToComponent,
    ContainersClientComponent,
    PdfKemfloComponent,
    ReceivingImportExcelComponent,
    ContainerListPdfComponent,
    ContainerBillOfLadingComponent,
    ImportShippingFaseOneComponent,
    ImportReceivingExcelReferenceComponent,
    InvoiceGenerateComponent,
    AddRateProductComponent,
    AddSendEmailComponent,
    ReceivingExportProdutsToShippingComponent,
    ReportProductReceiveridComponent,
    ExportShippingProductsComponent,
    WarehouseNameLocationComponent,
    WarehouseNameLocationViewComponent,
    LoginAppComponent,
    EditInventoryComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    GoogleMapsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,

    NgxMatColorPickerModule,

    ChartsModule,
    MatCardModule,
    MatTabsModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxFileDropModule,
    MatCheckboxModule,
    MatDividerModule,
    NgxBarcodeModule,
    ColorSketchModule,
    FontPickerModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    NgxSpinnerModule,
    MatListModule,
    MatBottomSheetModule,
    DataTablesModule,
    MatMenuModule,
    NgxDynamicTabindexModule
  ],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    {
      provide: FONT_PICKER_CONFIG,
      useValue: DEFAULT_FONT_PICKER_CONFIG
    },
    EncrDecrService,
    FontServiceService,
    MenuComponent,
    SignalRService,
    [{ provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true }],
    [{ provide: DEFAULT_TIMEOUT, useValue: 200000 }]
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    WarehouseNameLocationComponent,
    ExportShippingProductsComponent,
    ReportProductReceiveridComponent,
    ReceivingExportProdutsToShippingComponent,
    AddSendEmailComponent,
    AddRateProductComponent,
    ImportReceivingExcelReferenceComponent,
    ImportShippingFaseOneComponent,
    ContainerBillOfLadingComponent,
    ContainerListPdfComponent,
    ReceivingImportExcelComponent,
    PdfKemfloComponent,
    AddBillToComponent,
    ConfirmContainerItemsComponent,
    PdfBillOfLadingComponent,
    EditPalletCustomersComponent,
    ReceivePallentsComponent,
    AddTypeLocationsComponent,
    OpcionesComponent,
    PalletLabelComponent,
    MasivoConfimacionReceivingComponent,
    EditProductReceivingComponent,
    MenuComponent,
    ReportsComponent,
    ShippingComponent,
    DialogOverviewExampleDialog,
    ConfirmProductReceivingComponent,
    EditProductsItemsComponent,
    UpdateMoveInventoryComponent,
    CodeBarScannerComponent,
    ProductsComponent,
    AddProductsModalComponent,
    ClientComponent,
    DialogOverviewclientDialog
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
